import type { Plan } from "@/hooks/useSubscription";

export interface PlanFeature {
  label: string;
  free: boolean | string;
  starter: boolean | string;
  growth: boolean | string;
}

/**
 * Master feature matrix shared between the Pricing page and Settings.
 */
export const PLAN_FEATURE_MATRIX: PlanFeature[] = [
  { label: "Full SEO Audit", free: true, starter: true, growth: true },
  { label: "Keywords Analysis", free: true, starter: true, growth: true },
  { label: "AI Visibility Score", free: true, starter: true, growth: true },
  { label: "Ranking Prediction", free: true, starter: true, growth: true },
  { label: "Action Plan", free: false, starter: true, growth: true },
  { label: "Competitor Analysis", free: false, starter: true, growth: true },
  { label: "Link Intelligence", free: false, starter: true, growth: true },
  { label: "Dashboard Access", free: false, starter: true, growth: true },
  { label: "Content Editor", free: false, starter: false, growth: true },
  { label: "AI Chatbot", free: false, starter: false, growth: true },
  { label: "Backlink Opportunities", free: false, starter: false, growth: true },
  { label: "Monthly Audits", free: "1", starter: "10", growth: "Unlimited" },
];

/**
 * Compact list of features included for each plan (for the Settings card).
 */
export const PLAN_FEATURES: Record<Plan, string[]> = {
  free: PLAN_FEATURE_MATRIX
    .filter((f) => f.free === true || typeof f.free === "string")
    .map((f) => (typeof f.free === "string" ? `${f.label} (${f.free})` : f.label)),
  starter: PLAN_FEATURE_MATRIX
    .filter((f) => f.starter === true || typeof f.starter === "string")
    .map((f) => (typeof f.starter === "string" ? `${f.label} (${f.starter})` : f.label)),
  growth: PLAN_FEATURE_MATRIX
    .filter((f) => f.growth === true || typeof f.growth === "string")
    .map((f) => (typeof f.growth === "string" ? `${f.label} (${f.growth})` : f.label)),
};

/**
 * Locked features shown as a soft upgrade nudge for lower tiers.
 * Each entry includes the upgrade tier required.
 */
export const LOCKED_FOR: Record<Plan, { label: string; requires: "starter" | "growth" }[]> = {
  free: [
    { label: "Smart Action Plan", requires: "starter" },
    { label: "Competitor Analysis", requires: "starter" },
    { label: "AI Chatbot", requires: "growth" },
    { label: "Backlink Opportunities", requires: "growth" },
  ],
  starter: [
    { label: "Content Editor", requires: "growth" },
    { label: "AI Chatbot", requires: "growth" },
    { label: "Backlink Opportunities", requires: "growth" },
  ],
  growth: [],
};
